module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00682.80d23576.jpg";